export enum PoiType {
  HOTEL = 'HOTEL',
  HOSTEL = 'HOSTEL',
  STAMP = 'STAMP',
  ATTRACTION = 'ATTRACTION',
  VILLAGE = 'VILLAGE',
  PLACE = 'PLACE',
}
